import React from "react";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";

export default function YapilanUrunMusterisi() {
  const columns = [
    { key: "termin_tarihi", label: "Termin" },
    { key: "siparis_tarihi", label: "Sipariş Tarihi" },
    { key: "yapildigi_tarih", label: "Yapıldığı Tarih", render: (r) => <span className="text-indigo-700 font-medium">{r.yapildigi_tarih || "—"}</span> },
    { key: "musteri", label: "Müşteri" },
    { key: "urun_kodu", label: "Ürün Kodu", mono: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", mono: true },
    { key: "renk", label: "Renk" },
    { key: "siparis_adeti", label: "Sipariş", num: true },
    { key: "kalite_raporu", label: "Düşülen (1.Kalite)", num: true, render: (r) => <span className="text-green-700 font-semibold">{r.kalite_raporu ?? 0}</span> },
    { key: "kalan", label: "Kalan", num: true, render: (r) => <span className={`font-semibold ${(r.kalan ?? 0) > 0 ? "text-red-600" : "text-green-700"}`}>{r.kalan ?? 0}</span> },
  ];
  return (
    <>
      <PageHeader title="Yapılan Ürün Müşterisi" subtitle="1. kalitenin termine göre siparişlere düşürüldüğü kalemler" />
      <CrudTable
        endpoint="/reports/yapilan-urun-musterisi"
        listEndpoint="/reports/yapilan-urun-musterisi"
        columns={columns}
        readOnly
        selectable
        dateField="termin_tarihi"
        exportName="Yapılan Ürün Müşterisi"
      />
    </>
  );
}
